import React from 'react';
import Form from './Form'
import Leads from './Leads'

export default function Dashboard() {
    return (
        <>
            <Form />
            <Leads />
        </>
    )
}
